import React from "react";
import Card from "components/card";
import {
    BookOpen,
} from "lucide-react";
import CoursesTabs from "./CoursesTabs";
import HeaderComponent from "components/card/HeaderComponent";

const AssignedCoursesCard = ({ employee }) => {

    return (
        <HeaderComponent
            title="Assigned Courses & Milestones"
            titleClass="text-[18px] cxa"
            labelIcon={<BookOpen className="w-5 h-5 text-purple-600 dark:text-purple-500"/>}
            description="Track progress through structured learning paths" 
            descriptionClass="text-slate-500"     
        >
            <CoursesTabs employee={employee} />
        </HeaderComponent>
    );
};

export default AssignedCoursesCard;